import { render, staticRenderFns } from "./SelfieController.vue?vue&type=template&id=113bcf7e&scoped=true"
import script from "./SelfieController.vue?vue&type=script&lang=js"
export * from "./SelfieController.vue?vue&type=script&lang=js"
import style0 from "./SelfieController.vue?vue&type=style&index=0&id=113bcf7e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "113bcf7e",
  null
  
)

export default component.exports